module.exports = __webpack_public_path__ + "img/488e67cc51e7cc281717a51d568a8fdb.png";